export const UPLOADED = "UPLOADED";
export const REQUESTED = "REQUESTED";
export const APPROVED = "APPROVED";
export const REJECTED = "REJECTED";
export const NOT_REQUIRED = "NOT_REQUIRED";
